export default __webpack_public_path__ + "static/media/04.5b884f99.jpg";